export const summaryRows: string[] = [
  'Volume 1 — Engineering Fundamentals & Applied Mechanics',
  'Volume 2 — Engineering Materials & Strength of Components',
  'Volume 3 — Machine Elements & Mechanical Design',
  'Volume 4 — Thermodynamics, Fluid Mechanics & Heat Transfer',
  'Volume 5 — Manufacturing Processes & Industrial Production',
  'Volume 6 — Industrial Machinery, Reliability & Modern Engineering',
  'Bonus 1 — Mechanical Engineering Formula Reference',
  'Bonus 2 — Industrial Machinery & Components Handbook',
  'Bonus 3 — Mechanical Engineering Troubleshooting Guide',
  'Bonus 4 — Engineering Materials Selection Guide',
  'Bonus 5 — Mechanical Engineering Terminology Dictionary',
  '7-day money-back guarantee',
  'Instant access',
];
